export const CONSTANTS = {
	MOBILE_BREAKPOINT_WIDTH_CHECK: 768,
	getReportDownload(reportForm) {
		return `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: auto; border: 2px solid #000;">
                    <div style="display: flex; border-bottom: 2px solid #000">
                        <div style="padding: 0 20px; width: 100%">
                              <h1 style="text-align: center;">COTIZACION DE SEGURO</h1>
                              <h3 style="text-align: center;">FECHA: ${
																reportForm.date
															}</h3>
                              
                          </div>

                    </div>
                    <div style="display: flex; flex-direction: column; border-bottom: 2px solid #000; font-size: 14px">
                        <div style="">
                        <div style="display: flex; gap: 20px; padding: 0 20px">
                                              <h4>Datos de la persona</h4>
</div>
                      <div style="display: flex; gap: 20px; padding: 0 20px">
                            <div style="display: flex; flex: 1 1 50%; gap: 20px">
                          <p><i>Apellido:</i></p>
                          <p style="border-bottom: 1px solid #000; width: 100%">${
														reportForm?.quotationPersonalData?.lastName
													}</p>
                        </div>
                            <div style="display: flex; flex: 1 1 50%; gap: 20px">
                          <p><i>Nombre:</i></p>
                          <p style="border-bottom: 1px solid #000; width: 100%">${
														reportForm?.quotationPersonalData?.name
													}</p>
                        </div>
                          </div>
                          <div style="display: flex; gap: 20px; padding: 0 20px">
                            <div style="display: flex; flex: 1 1 50%; gap: 20px">
                          <p><i>Dirección:</i></p>
                          <p style="border-bottom: 1px solid #000; width: 100%">${
														reportForm?.emissionPersonalData?.address || ""
													}</p>
                        </div>
                            <div style="display: flex; flex: 1 1 50%; gap: 20px">
                          <p><i>Tel:</i></p>
                          <p style="border-bottom: 1px solid #000; width: 100%">${
														reportForm?.quotationPersonalData?.telephone || ""
													}</p>
                        </div>
                          </div>
                        </div>
                    </div>
                     <div style="display: flex; flex-direction: column; border-bottom: 2px solid #000; font-size: 14px">
                        <div style="">
                                              <div style="display: flex; gap: 20px; padding: 0 20px">
                                              <h4>Datos del vehículo</h4>
</div>
                      <div style="display: flex; gap: 20px; padding: 0 20px">
                            <div style="display: flex; flex: 1 1 50%; gap: 20px">
                          <p><i>Patente:</i></p>
                          <p style="border-bottom: 1px solid #000; width: 100%">${
														reportForm?.carData?.patent
													}</p>
                        </div>
                            <div style="display: flex; flex: 1 1 50%; gap: 20px">
                          <p><i>Año:</i></p>
                          <p style="border-bottom: 1px solid #000; width: 100%">${
														reportForm?.carData?.year
													}</p>
                        </div>
                          </div>
                          <div style="display: flex; gap: 20px; padding: 0 20px">
                            <div style="display: flex; flex: 1 1 50%; gap: 20px">
                          <p><i>Chasis:</i></p>
                          <p style="border-bottom: 1px solid #000; width: 100%">${
														reportForm?.emissionPersonalData?.carChasis || ""
													}</p>
                        </div>
                            <div style="display: flex; flex: 1 1 50%; gap: 20px">
                          <p><i>Motor:</i></p>
                          <p style="border-bottom: 1px solid #000; width: 100%">${
														reportForm?.emissionPersonalData?.carMotor || ""
													}</p>
                        </div>
                          </div>
                        </div>
                    </div>
                    <div style="display: flex; flex-direction: column; border-bottom: 2px solid #000; font-size: 14px">
                        <div style="">
                        <div style="display: flex; gap: 20px; padding: 0 20px">
                                              <h4>Datos del seguro</h4>
</div>
                      <div style="display: flex; gap: 20px; padding: 0 20px">
                            <div style="display: flex; flex: 1 1 50%; gap: 20px">
                          <p><i>Seguro contratado:</i></p>
                          <p style="border-bottom: 1px solid #000; width: 100%">${
														reportForm?.insuranceData?.coverage
													}</p>
                        </div>
                            <div style="display: flex; flex: 1 1 50%; gap: 20px">
                          <p><i>Mensual:</i></p>
                          <p style="border-bottom: 1px solid #000; width: 100%">$ ${
														reportForm?.insuranceData?.price
													}</p>
                        </div>
                          </div>
                          <div style="display: flex; gap: 20px; padding: 0 20px">
                            <div style="display: flex; flex: 1 1 50%; gap: 20px">
                          <p><i>Empresa:</i></p>
                          <p style="border-bottom: 1px solid #000; width: 100%">${
														reportForm?.insuranceData?.companyName || ""
													}</p>
                        </div>
                            <div style="display: flex; flex: 1 1 50%; gap: 20px">
                          <p><i>Franquicia:</i></p>
                          <p style="border-bottom: 1px solid #000; width: 100%">${
														reportForm?.insuranceData?.franchise
															? "SI"
															: "NO" || ""
													}</p>
                        </div>
                          </div>
                        </div>
                    </div>

                    <div style="display: flex; flex-direction: column; padding: 0 20px; font-size: 14px">
                            <div style="display: flex; gap: 20px; padding: 0 20px"><h4>Condiciones legales</h4></div>
                            <h5>Lorem ipsum <strong>odor amet</strong>, consectetuer adipiscing elit. Dictum litora facilisi rutrum aenean enim scelerisque. Arcu fames eros volutpat auctor scelerisque volutpat.</h5>
                            <div style="font-size: 12px">
                                <div>- Porta eu volutpat massa; id in dis elit.</div>
                                <div>- Potenti tristique ac litora commodo curabitur torquent euismod netus.</div>
                                <div>- Malesuada turpis tellus magnis per torquent.</div>
                            </div>
                            <h5>Id ornare mattis mus mattis dictumst ac eleifend.</h5>
                    </div>
          </div>
    `;
	},
};

export default CONSTANTS;
